import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import { ShareArticleSection } from "../ShareArticleSection";

const AmazonConnectManagedService = () => {
  return (
    <div className="modal-content-body case-studies-blk">
      <div className="modal-section">
        <div className="flex-content header-modal-case-studies">
          <div className="logo-section-modal">
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/aamc-thumbnail-iris.png"
              alt="AAMC"
            />
          </div>
          <div>
            <h3>Amazon Connect Managed Service & Intelligent AI Analytics</h3>
            <p>
              From Australia's #1 accident management provider to a data-driven,
              AI-optimised customer experience - powered by iCXeed.
            </p>
            <ShareArticleSection />
          </div>
        </div>
      </div>

      {/* Opportunity & Qualification */}
      <div className="modal-section">
        <h2 className="modal-section-title">Company Snapshot:</h2>
        <p className="title-description-blk">
          {/* AAMC is Australia's leading provider of specialist accident management
          and assessment for the motor insurance industry, serving hundreds of
          insurers with nation-wide coverage. Renowned for expertise,
          compliance, and continuous improvement, AAMC streamlines motor claims
          for personal, commercial, fleet, and rental portfolios. */}
          AAMC collaborated with iCXeed to maximize ROI and operational
          performance in their contact centre by leveraging innovative AWS
          solutions. The project deployed advanced analytics, AI-driven
          insights, and unified data integration to uncover optimisation
          opportunities, elevate contact centre data literacy, and improve key
          business outcomes.
        </p>
      </div>

      {/* Proposed Solution */}
      <div className="modal-section">
        <div className="flex-content-half">
          <div>
            <h2 className="modal-section-title">Challenge:</h2>
            <p>
              Like most large contact centres, AAMC faced challenges in
              synthesizing, processing, and analysing the vast data captured
              within the data lake of Amazon Connect.
              <br />
              <br />
              AAMC had enabled conversational analytics, automated QA, CSAT
              surveys, and advanced reporting via the Amazon Connect data lake.
              Yet, answering key questions about trends required extracting
              disparate datasets and manually listening to/categorizing call
              subsets, a time-consuming, resource-heavy process that pulled
              focus from improvement activities. They sought a faster path to
              insights on contact centre performance and high-impact
              opportunities for business process innovation.
              <br />
              <br />
              They needed to maximize ROI from all Amazon Connect capability and
              they needed to be guided by data on which solutions would deliver
              the greatest improvement in customer service and identify future
              additional opportunities for operational enhancement.
            </p>
          </div>
          <div>
            <h2 className="modal-section-title">AWS Solution:</h2>
            <p>
              {/* Working with iCXeed, AAMC deployed Amazon Connect Managed
              Services, optimising all flows and activating the full suite of AI
              bundle features—auto QA, Contact Lens sentiment analysis, Amazon
              Q, and advanced dashboards. Data lake querying and automated file
              archiving/remediation were enabled, with key details securely
              extracted and tracked in Power BI. Proprietary eLearning modules
              were implemented, empowering agents, supervisors, and admins with
              self-service training, while an IVR redesign delivered intuitive,
              customer-friendly call journeys. Power BI and Graph-based
              analytics supported root-cause analysis, skills coaching, abuse
              detection, and performance uplift. */}
              To solve these challenges, iCXeed partnered with AAMC to create a
              truly intelligent, data-driven contact centre, one capable of
              turning vast amounts of data into immediate, meaningful action.
              Using open and extendable frameworks built natively on AWS, iCXeed
              deployed a flexible AI-enabled solution that did not just unify
              information but transformed it into near real-time actionable
              business insights for operations.
              <br />
              <br />
              Rather than a static data platform, the new system acts like an AI
              data and business analyst, able to answer complex questions,
              identify emerging trends, and recommend improvements across
              customer experience, agent performance, and training.
              <br />
              <br />
              Through this solution, data from every customer interaction—calls,
              chats, surveys, and QA reviews—flows into a unified environment
              where AI continuously analyses, categorizes, and learns. Leaders
              can simply ask questions in natural language, such as “Which
              issues are trending this week?” or “Where can self-service deflect
              the most volume?”, and instantly receive data-backed answers,
              complete with visual and strategic context.
              <br />
              <br />
              This architecture enables AAMC’s contact centre to continually
              learn, adapt, and improve, creating a self-optimising customer
              experience operation. The result is not only deeper visibility but
              also faster, more confident decision-making. Together, iCXeed and
              AAMC have unlocked the true potential of Amazon Connect data,
              setting a new standard for AI-driven performance intelligence in
              customer operations.
            </p>
          </div>
        </div>
      </div>

      <div className="outcomes-result-blk">
        <h2 className="modal-section-title">Outcomes/Results:</h2>
        <ul>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>Increased Data Literacy</p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>Targeted Skill Development</p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>Continuous ROI Tracking</p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>Increased Workload Optimisation</p>
            </div>
          </li>
        </ul>
      </div>

      <div className="modal-footnote use-cases-footnote" style={{ border: 0 }}>
        <h4>Client Testimonial</h4>
        <h1>
          “iCXeed’s deep understanding of what AI could achieve with this amount
          of data was where the solution truly became game-changing. iCXeed’s
          vision of enabling more complex questions and positioning the AI as
          both a data and business analyst capable of providing business cases,
          training recommendations, and self-service improvements was ahead of
          its time. How could we not invest in this!”
        </h1>
        <div className="flex-box-blk client-details">
          <div>
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/mark-gwynne.png"
              alt="Stefan Hutton"
            />
          </div>
          <div>
            <h2>Mark Gwynne</h2>
            <p>Chief Information Officer</p>
            <p>Australian Accident Management Commercial (AAMC)</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmazonConnectManagedService;
